// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__yQgzP","spin":"Loader_spin__pT_zL"};